import Papa from 'papaparse';

interface DataDictionaryResponse {
  rows: Record<string, unknown>[];
  columns: string[];
  error?: string;
}

interface DownloadDataDictionaryOptions<T extends DataDictionaryResponse> {
  fileType: string;
  getDataDictionary: () => Promise<T>;
  onUnsupportedType?: (fileType: string) => void;
}

export async function downloadDataDictionary<T extends DataDictionaryResponse>({
  fileType,
  getDataDictionary,
  onUnsupportedType,
}: DownloadDataDictionaryOptions<T>): Promise<void> {
  const dataDictionary = await getDataDictionary();

  if (dataDictionary.error) {
    return;
  }

  let blob: Blob;
  let filename: string;

  if (fileType === 'json') {
    const jsonData = JSON.stringify(dataDictionary.rows, null, 2);
    blob = new Blob([jsonData], { type: 'application/json' });
    filename = 'dataDictionary.json';
  } else if (fileType === 'csv') {
    const csvData = Papa.unparse(dataDictionary.rows, { columns: dataDictionary.columns });
    blob = new Blob([csvData], { type: 'text/csv' });
    filename = 'dataDictionary.csv';
  } else {
    onUnsupportedType?.(fileType);
    return;
  }

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
